import { geocoding } from '@ooh/contracts';
import type { EndpointDef, callEndpoint, GeocodingSearchResponse } from '@ooh/contracts';

// ─── Shared auth interface ────────────────────────────────────

export interface WithCallWithAuth {
  callWithAuth: <TDef extends EndpointDef>(
    def: TDef,
    request: Parameters<typeof callEndpoint<TDef>>[1],
  ) => ReturnType<typeof callEndpoint<TDef>>;
}

// ─── Query key factory ────────────────────────────────────────

export const geocodingKeys = {
  all: ['geocoding'] as const,
  search: (q: string) => [...geocodingKeys.all, 'search', q] as const,
} as const;

// ─── Query factories ──────────────────────────────────────────

export function geocodingSearchQuery(auth: WithCallWithAuth, q: string) {
  return {
    queryKey: geocodingKeys.search(q),
    queryFn: (): Promise<GeocodingSearchResponse> => auth.callWithAuth(geocoding.search, { q }),
    // Never auto-refetch: geocoding results are stable.
    staleTime: Infinity,
    retry: false,
  };
}
